// import { Route } from 'react-router-dom';
import routesConfig from './routesConfig';
// import Transition from '../components/organisms/Transition';


export function generateRoutes() {
  return routesConfig.map((route) => ({
    path: route.path,
    element: route.element,
  }));
}
